<script setup lang="ts">
import { useAppVersion } from '@/composables/useAppVersion';

const { updateAvailable, refresh } = useAppVersion();
</script>

<template>
  <Transition name="slide-down">
    <div v-if="updateAvailable" class="app-update-banner">
      <div class="app-update-content">
        <i class="pi pi-refresh app-update-icon" />
        <span class="app-update-text">
          A new version of the app is available.
        </span>
        <button class="app-update-btn" @click="refresh">
          Refresh Now
        </button>
        <button class="app-update-dismiss" @click="updateAvailable = false" aria-label="Dismiss">
          <i class="pi pi-times" />
        </button>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.app-update-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  padding: 0.625rem 1rem;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
}

.app-update-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  max-width: 900px;
  margin: 0 auto;
  font-size: 0.875rem;
}

.app-update-icon {
  font-size: 1.1rem;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.app-update-text {
  font-weight: 500;
}

.app-update-btn {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.4);
  color: #fff;
  padding: 0.3rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.8125rem;
  font-weight: 600;
  transition: background 0.2s;
}

.app-update-btn:hover {
  background: rgba(255, 255, 255, 0.35);
}

.app-update-dismiss {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  padding: 0.25rem;
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  transition: color 0.2s;
}

.app-update-dismiss:hover {
  color: #fff;
}

/* Slide-down transition */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.slide-down-enter-from,
.slide-down-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}
</style>
